import { Button, Modal } from 'antd';

interface Props {
  index: number;
  onConfirmDelete: (index: number) => Promise<void>;
}
export const IndividualDeleteButton = (props: Props) => {
  const { index, onConfirmDelete } = props;
  const onClickDelete = () => {
    Modal.confirm({
      title: 'この読取り結果を削除しますか?',
      okText: 'はい',
      cancelText: 'いいえ',
      onOk: async () => {
        await onConfirmDelete(index);
      },
    });
  };

  return (
    <>
      <Button danger onClick={onClickDelete}>
        削除
      </Button>
    </>
  );
};
